<mat-icon appTooltip="{{ hints }}" class="small-icon">
    notes
</mat-icon>